//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import config from '@/config';
import { pests } from '@/api/api_url';
import { getToken, formatYMD } from '@/libs/util';
import { renderFormMixins } from '@/mixins/renderFormMixins';
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmCityList from 'vue-baidu-map/components/controls/CityList.vue';
import BmGeolocation from 'vue-baidu-map/components/controls/Geolocation.vue';
import BmMarker from 'vue-baidu-map/components/overlays/Marker.vue';
import BmLabel from 'vue-baidu-map/components/overlays/Label.vue';
import BmLocalSearch from 'vue-baidu-map/components/search/LocalSearch.vue';
import { project_list } from '@/api/pests';
export default {
  name: "addAppCustom",
  mixins: [renderFormMixins],
  data: function data() {
    return {
      sampling_valueData: [{
        name: "5" + this._vm.$t('分钟'),
        value: 300
      }, {
        name: "10" + this._vm.$t('分钟'),
        value: 600
      }, {
        name: "15" + this._vm.$t('分钟'),
        value: 900
      }, {
        name: "30" + this._vm.$t('分钟'),
        value: 1800
      }, {
        name: "1" + this._vm.$t('小时'),
        value: 3600
      }, {
        name: "2" + this._vm.$t('小时'),
        value: 7200
      }, {
        name: "3" + this._vm.$t('小时'),
        value: 10800
      }, {
        name: "5" + this._vm.$t('小时'),
        value: 18000
      }, {
        name: "12" + this._vm.$t('小时'),
        value: 43200
      }, {
        name: "24" + this._vm.$t('小时'),
        value: 86400
      }],
      headers: {
        Authorization: getToken()
      },
      hasDisabled: true,
      formModel: {
        sampling_value: null,
        did: null
      },
      formRules: {
        sampling_value: [{
          required: true,
          type: "number",
          message: this._vm.$t('采样频率不能为空'),
          trigger: 'change'
        }]
      }
    };
  },
  props: {
    _vm: {},
    edit: {},
    $store: {},
    setData: {},
    caiyang_pinglv: {},
    did: {},
    projectCode: {}
  },
  components: {
    BaiduMap: BaiduMap,
    BmGeolocation: BmGeolocation,
    BmCityList: BmCityList,
    BmMarker: BmMarker,
    BmLabel: BmLabel,
    BmLocalSearch: BmLocalSearch
  },
  computed: {
    getAction: function getAction() {
      var result = '';

      if (process.env.NODE_ENV === 'development') {
        result = config.baseUrl.dev + "" + pests.upload_file;
      } else if (process.env.VUE_APP_BUILD === 'production') {
        result = config.baseUrl.pro + "" + pests.upload_file;
      } else {
        result = config.baseUrl.alp + "" + pests.upload_file;
      }

      return result;
    }
  },
  methods: {},
  mounted: function mounted() {
    //debugger
    //console.log("aa",this.caiyang_pinglv)
    this.formModel.did = this.did;
    this.formModel.sampling_value = parseInt(this.caiyang_pinglv);
  },
  created: function created() {//this.init()
  }
};